import styles from "../bussiness.module.css";
import "./cstyle.css";
import { useState, useEffect } from "react";
import axios from "axios";
import toast from "react-hot-toast";
// import { connection } from "utils/apiConnection.ts";
import { AiFillLeftCircle } from "react-icons/ai";
import { AiOutlinePlus } from "react-icons/ai";

import DeleteBussiness from "./DeleteBussiness";
import ManagementCommission from "./ManagementCommission.jsx";
import BoxCustomer from "./BoxCustomer";
import { FaFilter, FaTrashAlt } from "react-icons/fa";
import FilterModalBusiness from "./Filter";
import _ from "lodash";
import AddSupplier from "./AddSupplier";
import LineModal from "./LineModal";
import EditSupplier from "./EditSupplier";
import ReactPaginate from "react-paginate";
import Loader from "../../kits/Loader";
import StopBussiness from "./StopBussiness";

import useAxios from "../../../services/useAxios";

const BusinessList = ({ marketer }) => {
  const [selectedItem, setSelectedItem] = useState(1);
  const [customers, setCustomers] = useState([]);
  const [links, setLinks] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const usersPerPage = 12;
  const pageVisited = pageNumber * usersPerPage;
  const [updater, setUpdater] = useState(false);
  const [allProductTags, setAllProductTags] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [allLeader, setAllLeader] = useState([]);
  const [editModalData, setEditModalData] = useState([]);
  const [otherInfo, setOtherInfo] = useState({
    suppliers__id: 0,
    bank_info: "",
    title: "",
    token: "",
    main_admin_uid: "",
    user_mobile: "",
    fullname: "",
    cover_file_id: [],
    path: [],
    logo_file_id: [],
    main_cat: "",
    line_ids: [],
    description: "",
    // endTime: "",
    // startTime: "",
    start_hour: "",
    start_min: "",
    finish_hour: "",
    finish_min: "",
    site: "",
    instagram: "",
    tell1: "",
    tell2: "",
    email: "",
    mobile: "",
    address: "",
    min_order_amount: "",
  });
  const { loading, execute: getSupplierApi } = useAxios(
    "superadminapi/getsuppliers"
  );
  const { loadingSupplierData, execute: getAddSupplierDataApi } = useAxios(
    "superadminapi/get_add_suppliers_data"
  );
  const { loadingEditSupplierData, execute: getAddEditSupplierDataApi } =
    useAxios("superadminapi/get_add_edit_product_data");
  const { updateSupplier, execute: updateSupplierApi } = useAxios(
    "api/Update_suppliers"
  );

  useEffect(() => {
    setIsLoading(true);
    let mk;
    if (marketer == true) {
      mk = { mine: true };
    } else {
      mk = { isSuperAdmin: true };
    }
    console.log("marketer : ,", marketer);
    async function loadPage() {
      // let result = await connection("superadminapi/getsuppliers", {
      //   mine: true,
      // });
      //   *----------*

      getSupplierApi(mk).then((result) =>
        setCustomers(_.orderBy(result.data, ["info.mtm"], ["desc"]))
      );
      //   let result = await connection("superadminapi/getsuppliers", mk);
      //   setCustomers(_.orderBy(result.data, ["info.mtm"], ["desc"]));
      // *---------*
      // let x = [];
      // for (let index = 0; index < result.data.length; index++) {
      //   let newObject = {};
      //   newObject = result.data[index].info;
      //   x.push(newObject);
      // }
      // let links = [];
      // for (let index = 0; index < result.data.length; index++) {
      //   let newObject = {};
      //   newObject = result.data[index].lines_link;
      //   links.push(newObject);
      // }
      // let xy = x;
      // setLinks(links);

      // setCustomers(xy);
      setIsLoading(false);
    }
    loadPage();
  }, [updater]);
  const pageCountt = Math.ceil(customers?.length / usersPerPage);
  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };
  console.log("object test", allLeader);
  // const editHandler = (item, lineOption) => {
  //   setOtherInfo({
  //     suppliers__id: item.suppliers__id,
  //     bank_info: item.bank_info,
  //     site: item.site,
  //     instagram: item.instagram,
  //     title: item.title,
  //     token: item.token,
  //     // main_admin_uid: [...selectedtags],
  //     main_admin_uid: item.main_admin_uid,
  //     user_mobile: item.user_mobile,
  //     fullname: item.fullname,
  //     cover_file_id: item.cover_file_id,
  //     logo_file_id: item.path,
  //     main_cat: item.main_cat,
  //     // line_ids: [...selectedlinks],
  //     line_ids: lineOption,
  //     description: item.description,
  //     //   endTime:item.endTime,
  //     // startTime:item.startTime,
  //     start_hour: item.start_hour,
  //     start_min: item.start_min,
  //     finish_hour: item.finish_hour,
  //     finish_min: item.finish_min,
  //     tell1: item.tell1,
  //     tell2: item.tell2,
  //     email: item.email,
  //     mobile: item.mobile,
  //     address: item.address,
  //     min_order_amount: item.min_order_amount,
  //     // suppliers__id: chars[index].suppliers__id,
  //     // title: chars[index].title,
  //     // token: chars[index].token,
  //     // main_admin_uid: [...selectedtags],
  //     // user_mobile: chars[index].user_mobile,
  //     // fullname: chars[index].fullname,
  //     // cover_file_id: chars[index].cover_file_id,
  //     // logo_file_id: chars[index].path,
  //     // main_cat: chars[index].main_cat,
  //     // line_ids: [...selectedlinks],
  //     // description: chars[index].description,
  //     // //   endTime:chars[index].endTime,
  //     // // startTime:chars[index].startTime,
  //     // start_hour: chars[index].start_hour,
  //     // start_min: chars[index].start_min,
  //     // finish_hour: chars[index].finish_hour,
  //     // finish_min: chars[index].finish_min,
  //     // tell1: chars[index].tell1,
  //     // tell2: chars[index].tell2,
  //     // email: chars[index].email,
  //     // mobile: chars[index].mobile,
  //     // address: chars[index].address,
  //     // min_order_amount: chars[index].min_order_amount,
  //   });
  //   setSelectedItem(item.suppliers__id);

  //   let revLink = links.reverse();
  //   // let text = chars[index].main_admin_uid;
  //   let text = item.main_admin_uid;
  //   const myArray = text.split(" ");

  //   let selectedtags = allUsers.filter((value) => {
  //     for (let index = 0; index < myArray.length; index++) {
  //       if (myArray[index] == value.value) return true;
  //     }
  //     return false;
  //   });

  //   // let selectedlinks = allProductTags.filter((value) => {
  //   //   for (let i = 0; i < revLink[index].length; i++) {
  //   //     if (revLink[index][i].suppliers_line_id == value.value) return true;
  //   //   }
  //   //   return false;
  //   // });
  // };
  useEffect(() => {
    async function loadPage() {
      // let result = await connection("superadminapi/get_add_suppliers_data", {});
      getAddSupplierDataApi().then((result) => {
        let allUsers = [];
        let all = [];
        for (let index = 0; index < result.user_for_admin.length; index++) {
          let newObject = {};
          newObject.value = result.user_for_admin[index].id;
          newObject.label = result.user_for_admin[index].fullname;
          allUsers.push(newObject);
        }
        setAllUsers(allUsers);
        for (let index = 0; index < result.lines.length; index++) {
          let newObject = {};
          newObject.value = result.lines[index].id;
          newObject.label = result.lines[index].title;
          newObject.main_cat = result.lines[index].main_cat;
          newObject.parent_line_id = result.lines[index].parent_line_id;

          all.push(newObject);
        }
        setAllProductTags(all);
      });
    }
    loadPage();
  }, []);
  //   useEffect(() => {
  //     async function loadPage() {
  //       let result = await connection("superadminapi/get_add_suppliers_data", {});

  //       let all = [];
  //       for (let index = 0; index < result.lines.length; index++) {
  //         let newObject = {};
  //         newObject.value = result.lines[index].id;
  //         newObject.label = result.lines[index].title;
  //         newObject.main_cat = result.lines[index].main_cat;
  //         newObject.parent_line_id = result.lines[index].parent_line_id;
  //         all.push(newObject);
  //       }
  //       setAllProductTags(all);
  //     }
  //     loadPage();
  //   }, []);

  useEffect(() => {
    async function loadPage() {
      // let data = await connection(
      //   "superadminapi/get_add_edit_product_data",
      //   {}
      // );
      getAddEditSupplierDataApi().then((data) => {
        let allLeader = [];
        for (let index = 0; index < data.cats.length; index++) {
          let newObject = {};
          newObject = data.cats[index];

          allLeader.push(newObject);
        }
        setAllLeader(allLeader);
      });
    }
    loadPage();
  }, []);
  // ----------
  // let chars = _.orderBy(customers, ["mtm"], ["desc"]);

  const [filterInputs, setFilterInputs] = useState({
    title: "",
    complate_order_count_from: "",
    complate_order_count_to: "",
    active_order_count_from: "",
    active_order_count_to: "",
    canceled_order_count_from: "",
    canceled_order_count_to: "",
    total_saled_amount_from: "",
    total_saled_amount_to: "",
    muid: "",
  });
  const selectDataEdit = (customers, lineOption) => {
    console.log("otherInfo sssss func");
    setEditModalData({
      ...customers,
      title: customers?.info?.title,
      lineOption: lineOption,
    });
  };

  async function search() {
    setIsLoading(true);
    let myFormData = new FormData();
    if (filterInputs.title !== "") {
      myFormData.append("keyword", filterInputs.title);
    }
    if (filterInputs.complate_order_count_from !== "") {
      myFormData.append(
        "complate_order_count_from",
        filterInputs.complate_order_count_from
      );
    }
    if (filterInputs.complate_order_count_to !== "") {
      myFormData.append(
        "complate_order_count_to",
        filterInputs.complate_order_count_to
      );
    }
    if (filterInputs.active_order_count_from !== "") {
      myFormData.append(
        "active_order_count_from",
        filterInputs.active_order_count_from
      );
    }
    if (filterInputs.active_order_count_to !== "") {
      myFormData.append(
        "active_order_count_to",
        filterInputs.active_order_count_to
      );
    }
    if (filterInputs.canceled_order_count_from !== "") {
      myFormData.append(
        "canceled_order_count_from",
        filterInputs.canceled_order_count_from
      );
    }
    if (filterInputs.canceled_order_count_to !== "") {
      myFormData.append(
        "canceled_order_count_to",
        filterInputs.canceled_order_count_to
      );
    }
    if (filterInputs.total_saled_amount_from !== "") {
      myFormData.append(
        "total_saled_amount_from",
        filterInputs.total_saled_amount_from
      );
    }
    if (filterInputs.total_saled_amount_to !== "") {
      myFormData.append(
        "total_saled_amount_to",
        filterInputs.total_saled_amount_to
      );
    }
    if (filterInputs.muid !== "") {
      myFormData.append("muid", filterInputs.muid.value);
    }
    getSupplierApi(myFormData).then((res) => {
      // console.log("res.data", res.data.size);
      res.data.size == 0 ? setCustomers(0) : setCustomers(res.data);
      // setCustomers(res.data.data.map((v) => v.info));
      setIsLoading(false);
    });
    // axios
    //   .post(
    //     "http://old-sabadib.tatdemo.ir/superadminapi/getsuppliers",
    //     myFormData
    //   )
    //   .then((res) => {
    //     // console.log("res.data", res.data.size);
    //     res.data.size == 0 ? setCustomers(0) : setCustomers(res.data.data);
    //     // setCustomers(res.data.data.map((v) => v.info));
    //     setIsLoading(false);
    //   });
  }

  async function resetFilters() {
    setIsLoading(true);
    setFilterInputs({
      title: "",
      complate_order_count_from: "",
      complate_order_count_to: 0,
      active_order_count_from: "",
      active_order_count_to: "",
      canceled_order_count_from: "",
      canceled_order_count_to: "",
      total_saled_amount_from: "",
      total_saled_amount_to: "",
      muid: "",
    });
    setUpdater(!updater);
    setIsLoading(false);
  }

  const deleteHandler = (id) => {
    setIsLoading(true);
    let myFormData = new FormData();
    myFormData.append("keyvalues", `main_status,-1`);
    myFormData.append("conditions", `id/=/${id}`);
    updateSupplierApi(myFormData).then((res) => {
      if (res.status == 1) {
        toast.success("  کسب و کار با موفقیت حذف شد");
        setUpdater(!updater);
        setIsLoading(false);
      } else {
        toast.error("  خطا در حذف کردن کسب و کار!");
        setIsLoading(false);
      }
    });
    // axios
    //   .post(`http://old-sabadib.tatdemo.ir/api/Update_suppliers`, myFormData)
    //   .then((res) => {
    //     if (res.data.status == 1) {
    //       toast.success("  کسب و کار با موفقیت حذف شد");
    //       setUpdater(!updater);
    //       setIsLoading(false);
    //     } else {
    //       toast.error("  خطا در حذف کردن کسب و کار!");
    //       setIsLoading(false);
    //     }
    //   });
  };
  const stopHandler = (id) => {
    setIsLoading(true);
    let myFormData = new FormData();
    myFormData.append("keyvalues", `main_status,-2`);
    myFormData.append("conditions", `id/=/${id}`);
    updateSupplierApi(myFormData).then((res) => {
      if (res.status == 1) {
        toast.success("  کسب و کار با موفقیت متوقف شد");
        setUpdater(!updater);
        setIsLoading(false);
      } else {
        toast.error("  خطا در متوقف کردن کسب و کار!");
        setIsLoading(false);
      }
    });
    // axios
    //   .post(`http://old-sabadib.tatdemo.ir/api/Update_suppliers`, myFormData)
    //   .then((res) => {
    //     if (res.data.status == 1) {
    //       toast.success("  کسب و کار با موفقیت متوقف شد");
    //       setUpdater(!updater);
    //       setIsLoading(false);
    //     } else {
    //       toast.error("  خطا در متوقف کردن کسب و کار!");
    //       setIsLoading(false);
    //     }
    //   });
  };
  const activeHandler = (id) => {
    setIsLoading(true);
    let myFormData = new FormData();
    myFormData.append("keyvalues", `main_status,0`);
    myFormData.append("conditions", `id/=/${id}`);

    updateSupplierApi(myFormData).then((res) => {
      if (res.status == 1) {
        toast.success("  کسب و کار با موفقیت فعال شد");
        setUpdater(!updater);
        setIsLoading(false);
      } else {
        toast.error("  خطا در فعال کردن کسب و کار!");
        setIsLoading(false);
      }
    });
    // axios
    //   .post(`http://old-sabadib.tatdemo.ir/api/Update_suppliers`, myFormData)
    //   .then((res) => {
    //     if (res.data.status == 1) {
    //       toast.success("  کسب و کار با موفقیت فعال شد");
    //       setUpdater(!updater);
    //       setIsLoading(false);
    //     } else {
    //       toast.error("  خطا در فعال کردن کسب و کار!");
    //       setIsLoading(false);
    //     }
    //   });
  };
  console.log("otherInfo ssssssss p1", otherInfo);
  return (
    <div className="container w-100 h-100 d-flex flex-column">
      {/* <div className="d-flex border w-100">
        <div className=" border-end" style={{ width: "20%" }}>
          <h5>لاینها</h5>
          <div>
            آرایشی بهداشتی , آجیل و خشکبار , پسته , بادام زمینی , بادام درختی ,
            بادام هندی , تخمه کدو , تخمه ژاپنی , تخمه آفتابگردان , فندق , گردو ,
            انجیر خشک و توت , میوه , میوه روز , میوه خاص , کنسرو و غذای اماده ,
            خورشت , سوپ , فست فودهای آماده , پروتئینی آماده
          </div>
        </div>
        <div className={``} style={{ width: "80%" }}>
          <div className="d-flex border-bottom ">
            <div className="border-end" style={{ width: "70%" }}>
              <h5 className="border-bottom">عنوان</h5>
              <div>عنوان فروشگاه</div>
            </div>
            <div className="border-end" style={{ width: "30%" }}>
              <h5 className="border-bottom">لوگو</h5>
              <div>لوگو فروشگاه</div>
            </div>
          </div>
          <div className="d-flex border-bottom">
            <div className="border-end" style={{ width: "25%" }}>
              <h5 className="border-bottom">امار1</h5>
              <div>7777</div>
            </div>
            <div className="border-end" style={{ width: "25%" }}>
              <h5 className="border-bottom">امار2</h5>
              <div>9999</div>
            </div>
            <div className="border-end" style={{ width: "25%" }}>
              <h5 className="border-bottom">امار 3</h5>
              <div>555</div>
            </div>
            <div className="border-end" style={{ width: "25%" }}>
              <h5 className="border-bottom">امار4</h5>
              <div>9999</div>
            </div>
          </div>
          <div className="d-flex border-bottom">
            <div className="border-end" style={{ width: "70%" }}>
              <h5 className="border-bottom">توضیحات</h5>
              <div>
                تتتتتتتتتتتتتتتتتتتتتتت تتتتتتتتتتتتتتتتتتتتتتتتتت تمدئ{" "}
              </div>
            </div>
            <div className="border-end" style={{ width: "30%" }}>
              <h5 className="border-bottom">عملیات</h5>
              <div> 8 8 8 8 8 88</div>
            </div>
          </div>
        </div>
      </div> */}
      {loading ? (
        <div className="d-flex align-items-center justify-content-center flex-grow-1">
          {" "}
          <Loader width={40} />
        </div>
      ) : customers?.length > 0 ? (
        customers
          .slice(pageVisited, pageVisited + usersPerPage)
          .map((item, index) => {
            return (
              <div>
                <BoxCustomer
                  item={item.info}
                  allProductTags={allProductTags}
                  setAllProductTags={setAllProductTags}
                  allLeader={allLeader}
                  setAllLeader={setAllLeader}
                  key={item.id}
                  allUsers={allUsers}
                  links={item.lines_link}
                  setLinks={setLinks}
                  setAllUsers={setAllUsers}
                  // chars={chars}
                  customers={customers[index]}
                  selectedItem={selectedItem}
                  setSelectedItem={setSelectedItem}
                  setCustomers={setCustomers}
                  index={index}
                  otherInfo={otherInfo}
                  setOtherInfo={setOtherInfo}
                  deleteHandler={() => deleteHandler(item.id)}
                  stopHandler={() => stopHandler(item.suppliers__id)}
                  // setEditModalData={setEditModalData}
                  selectDataEdit={selectDataEdit}
                  editModalData={editModalData}
                  activeHandler={activeHandler}
                  // editHandler={editHandler}
                />
              </div>
            );
          })
      ) : (
        <p>کسب و کار وجود ندارد</p>
      )}

      <div className=" d-flex justify-content-center">
        <ReactPaginate
          // breakLabel={<a href="">...</a>}
          previousLabel={"<"}
          nextLabel={">"}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          pageCount={pageCountt}
          onPageChange={changePage}
          containerClassName={"paginationBttn"}
          activeClassName={"paginationActive"}
          disabledClassName={"paginationDisabled"}
          nextLinkClassName={"nextBttn"}
          previousLinkClassName={"previousBttn"}
        />
      </div>

      <FilterModalBusiness
        filterInputs={filterInputs}
        setFilterInputs={setFilterInputs}
        search={search}
        resetFilters={resetFilters}
      />
      <AddSupplier
        setUpdater={setUpdater}
        updater={updater}
        setIsLoading={setIsLoading}
      />
      <LineModal />
      <EditSupplier
        setIsLoading={setIsLoading}
        editModalData={editModalData}
        index={selectedItem}
        setUpdater={setUpdater}
        updater={updater}
        customers={customers}
        EditUser={setCustomers}
        otherInfo={otherInfo}
        setOtherInfo={setOtherInfo}
        allProductTags={allProductTags}
        allUsers={allUsers}
        allLeader={allLeader}
        setAllLeader={setAllLeader}
        setAllUsers={setAllUsers}
        setAllProductTags={setAllProductTags}
      />
      {/* <!--Modal Trash--> */}
      <DeleteBussiness
        index={selectedItem}
        customers={customers}
        deleteHandler={deleteHandler}
      />
      <StopBussiness
        index={selectedItem}
        customers={customers}
        stopHandler={stopHandler}
      />
      {/* <ManagementCommission index={selectedItem} otherInfo={otherInfo} /> */}
      {/* <!--Modal Edit--> */}
    </div>
  );
};

export default BusinessList;
